import {getProductPics,getImageTypeList,getImageList,deleteImage, addProductPic, removeProductPic,clearProductPicByProId,ensureSelectPicList,changeImageListSort} from '@/api/api'

const state = {
    PictureData:[],
    pictureType:[],
    pictureTabs:{},
    pictureList:{
        list:[],
        total:0
    },
    productPicTabs:[{
        name:'详情页大图',
        type:'1',
        limitCount:999
    },{
        name:'首页列表图',
        type:'2',
        limitCount:999
    },{
        name:'营养图',
        type:'3',
        limitCount:999
    },{
        name:'长期订购图',
        type:'4',
        limitCount:999
    },{
        name:'小图',
        type:'5',
        limitCount:999
    },{
        name:'详情页图',
        type:'6',
        limitCount:999
    },{
        name:'推荐图',
        type:'7',
        limitCount:999
    }],
    vipPicTabs:[{
        name:'亮ICON',
        type:'1',
        limitCount:1
    },{
        name:'弹窗图',
        type:'2',
        limitCount:1
    }],
    dialogFormVisiblePicAdd:false
};
const getters = {
    getPicture:function (state) {
        return state.PictureData
    },
    getPictureType:function (state) {
        return state.pictureType
    },
    getPictureList:function (state) {
        return state.pictureList
    },
    getPictureTabs:function (state) {
        return state.pictureTabs
    }
};
const actions = {
    initPicture({commit,state},param){
        return new Promise((resolve) => {
            getProductPics(param).then((res) => {
                commit('INIT_PICTURE',res.data.value);
                resolve(res)
            })
        })
    },
    initPictureList({commit,state},param){
        getImageList(param.pageInfo).then((res) => {
            let resData = res.data.value
            param.selectList.map(item=>{
                resData.list = (resData.list||[]).map(item1=>{
                    if(item1.imageId==item.imageId){
                        item1.select = item.select
                    }
                    return item1
                })
            })
            commit('INIT_PICTURE_LIST',resData);

        })
    },
    initPictureType({commit,state},param){
        return new Promise((resolve) => {
            getImageTypeList(param).then((res) => {
                commit('INIT_PICTURETYPE',res.data);
                resolve(res.data)
            })
        })
    },
    initPictureTabs({commit,state},param){
        commit('INIT_PICTURE_TABS',state.productPicTabs);
    },
    selectPicture({commit,state},param){
        return new Promise((resolve) => {
            addProductPic(param).then((res) => {
                resolve(res.data)
            })
        })
    },
    ensurePicList({commit,state},param){
        return new Promise((resolve) => {
            ensureSelectPicList(param).then((res) => {
                resolve(res.data)
            })
        })
    },
    delPicListImg({commit,state},param){
        return new Promise((resolve) => {
            deleteImage(param).then((res) => {
                resolve(res.data)
            })
        })
    },
    delProImg({commit,state},param){
        return new Promise((resolve) => {
            removeProductPic(param).then((res) => {
                resolve(res.data)
            })
        })
    },
    clearProductPic({commit,state},param){
        return new Promise((resolve) => {
            clearProductPicByProId(param).then((res) => {
                resolve(res.data)
            })
        })
    },
    changePicListSort({commit,state},param){
        changeImageListSort(param).then((res) => {
            // commit('INIT_PICTURE',res.data.value);
        })
    }
};
let mutations = {
    INIT_PICTURE(state,param){
        state.PictureData = param
    },
    SET_PIC_DIALOG(state,param){
        state.dialogFormVisiblePicAdd = param
    },
    INIT_PICTURETYPE(state,param){
        state.pictureType = param
    },
    INIT_PICTURE_LIST(state,param){
        if(param.list){
            state.pictureList = param
        }
    },
    INIT_PICTURE_TABS(state,param){
        state.pictureTabs = param
    }
}

export default {
    state,
    getters,
    actions,
    mutations,
}


// WEBPACK FOOTER //
// ./src/store/modules/picList.js